import { render, staticRenderFns } from "./CardServicosFinalizados.vue?vue&type=template&id=2eb7bbb3&"
import script from "./CardServicosFinalizados.vue?vue&type=script&lang=js&"
export * from "./CardServicosFinalizados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports